export const DEPARTAMENTOS = 'DEPARTAMENTOS';
export const CICLOS_ESCOLARES = 'CICLOS_ESCOLARES';
export const INFO = 'INFO';
export const PLANES_ESTUDIO = 'PLANES_ESTUDIO';
export const CONJUNTO_PERIODOS = 'CONJUNTO_PERIODOS';
export const LABELS = 'LABELS';
export const ESTRUCTURA_CUSTOMNAMES = 'ESTRUCTURA_CUSTOMNAMES';
export const PARAMETROS = 'PARAMETROS'